// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__xjmLD","title_headline":"style_title_headline__2VBz-","text_center":"style_text_center__1vKGa","text_left":"style_text_left__2clFK","text":"style_text__uImsm"};